var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionUmbrellaColored({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 17L7 18C7 19.6569 8.34314 21 10 21C11.6569 21 13 19.6569 13 18L13 3C13 2.44772 12.5523 2 12 2C11.4477 2 11 2.44772 11 3L11 18C11 18.5523 10.5523 19 10 19C9.44771 19 9 18.5523 9 18L9 17C9 16.4477 8.55228 16 8 16C7.44771 16 7 16.4477 7 17Z",
    fill: "#5714CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.18381 13.5898C4.46366 13.2679 4 12.5527 4 11.7639L4 11C4 6.58172 7.58172 3 12 3C16.4183 3 20 6.58172 20 11V11.7639C20 12.5527 19.5363 13.2679 18.8162 13.5898C18.096 13.9117 17.254 13.7802 16.6662 13.2542C16.4879 13.0946 16.2574 13 16 13C15.7426 13 15.5121 13.0946 15.3338 13.2542C14.5745 13.9338 13.4255 13.9338 12.6662 13.2542C12.4879 13.0946 12.2574 13 12 13C11.7426 13 11.5121 13.0946 11.3338 13.2542C10.5745 13.9338 9.42553 13.9338 8.66617 13.2542C8.48793 13.0946 8.2574 13 8 13C7.7426 13 7.51207 13.0946 7.33383 13.2542C6.74605 13.7802 5.90395 13.9117 5.18381 13.5898Z",
    fill: "#5714CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 11.7639C6.53076 11.2889 7.23165 11 8 11C8.76835 11 9.46924 11.2889 10 11.7639C10.5308 11.2889 11.2316 11 12 11C12.7684 11 13.4692 11.2889 14 11.7639C14.5308 11.2889 15.2316 11 16 11C16.7684 11 17.4692 11.2889 18 11.7639L18 11C18 7.68629 15.3137 5 12 5C8.68629 5 6 7.68629 6 11L6 11.7639Z",
    fill: "#FFC30D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionUmbrellaColored);
export default __webpack_public_path__ + "static/media/ic_action_umbrella_colored.2ef13ceaab8fde1f48c9f87f5b34e20b.svg";
export { ForwardRef as ReactComponent };